// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-color-dark:#95b2d0;
    --secondary-color-dark: #245589;
    --accent-color-dark: #4894e5;
    --background-color-dark: #040506;
    --text-color-dark: #eff0f1;

    --primary-color-light:#2f4c6a;
    --secondary-color-light: #76a7db;
    --accent-color-light: #1a66b7;
    --background-color-light: #f9fafb;
    --text-color-light: #0e0f10;
}

* {
    margin: 0;
    padding: 0;
    /* border: 1px solid red; */
}

body{
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    font-family: 'Roboto', sans-serif;
    min-height: 100vh;
    overflow-x: hidden;
    background-color: var(--background-color-dark);
}

button {
    font-family: 'Roboto', sans-serif;
}

header {
    background-color: var(--background-color-dark);
}

li {
    list-style-type: none;
}

.block {
    display: block;
}

.inline {
    display: inline;
}

.flex {
    display: flex;
}

.hidden {
    display: none;
}

.over-hidden {
    overflow-x: hidden;
}

.wrap {
    flex-wrap: wrap;
}

.justify-between {
    justify-content: space-between;
}

.justify-center {
    justify-content: center;
}

.justify-stretch {
    justify-content: stretch;
}

.items-center {
    align-items: center;
}

.text-center {
    text-align: center;
}

.text-white {
    color: var(--text-color-dark);
}

.text-primary-dark {
    color: var(--primary-color-dark);
}

.text-secondary-dark {
    color: var(--secondary-color-dark);
}

.text-accent-dark {
    color: var(--accent-color-dark);
}

/* .bg-radient {
    background-image: ;
} */

.bg-color-dark {
    background-color: var(--background-color-dark);
}

.bg-color-light {
    background-color: var(--background-color-light);
}

.accent-color-dark {
    background-color: var(--accent-color-dark);
}

.secondary-color-dark {
    background-color: var(--secondary-color-dark);
}

.primary-color-dark {
    background-color: var(--primary-color-dark);
}

.px-18 {
    padding-left: 18px;
    padding-right: 18px;
}

.px-24 {
    padding-left: 24px;
    padding-right: 24px;
}

.px-48 {
    padding-left: 3rem;
    padding-right: 3rem;
}

.pt-12 {
    padding-top: 12px;
}

.py-12 {
    padding-top: 12px;
    padding-bottom: 12px;
}

.py-18 {
    padding-top: 18px;
    padding-bottom: 18px;
}

.pl-50per {
    padding-left: 50%;
}

.pl-16 {
    padding-left: 1rem;
}

.p-46 {
    padding: 46px;
}

.m-36 {
    margin-right: 36px;
}

.m-8 {
    margin-right: 8px;
}

.mt-42 {
    margin-top: 44px;
}

.mt-24 {
    margin-top: 24px;
}

.mt-16 {
    margin-top: 1rem;
}

.mb-8 {
    margin-bottom: 8px;
}

.mb-16 {
    margin-bottom: 16px;
}

.no-underline {
    text-decoration: none;
}

.no-border {
    border: none;
}

.br-5 {
    border-radius: 5px;
}

.br-10 {
    border-radius: 10px;
}

.bold {
    font-weight: bold;
}

.uppercase {
    text-transform: uppercase;
}

.letter-spacing {
    letter-spacing: 1px;
}

.letter-spacing-13 {
    letter-spacing: 0.13px;
}

.w-full {
    width: 100%;
}

.h-full {
    height: 100%;
}

h-100 {
    height: 100vh;
}

.max-img {
    max-height: 100%;
    max-width: 100%;
}

.object-contain {
    object-fit: contain;
}

.relative {
    position: relative;
}

.absolute {
    position: absolute;
}

.z-10 {
    z-index: 10;
}

.mx-auto {
    margin-left: auto;
    margin-right: auto;
}

.mx-width {
    max-width: 1200px;
}

.mx-img-section {
    max-width: 800px;
    max-height: 500px;
    margin: 0 auto;
}

.box-shadow {
    box-shadow: 0 5px 10px rgba(0,0,0,0.2);
}

.opacity-light {
    opacity: 0.33;
}

.sidebar {
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    width: 250px;
    z-index: 999;
    background-color: var(--primary-color-dark);
    backdrop-filter: blur(10px);
    box-shadow: -10px 0 10px rgba(0, 0, 0, 0.1);
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    
}

.sidebar li {
    width:100%;
}

.sidebar a {
    width:100%;
}

.nav-hover:hover {
    background-color: var(--accent-color-dark);
    border-radius: 3px;
}

.nav-button {
    transition: transform 0.3 ease;
}

.nav-button:hover {
    background-color: var(--secondary-color-dark);
    transform: scale(1.125);

}

@media (min-width: 640px) {
    .sm\\:text-55px {    
        font-size: 55px;
    }

    .sm\\:text-20px {
        font-size: 1.125rem;
    }

    .sm\\:inline {
        display: inline;
    }

    .sm\\:mt--16 {
        margin-top: -16px;
    }

    .sm\\:hidden {
        display: none;
    }

    .sm\\:flex {
        display: flex;
    }

    .sm\\:pl-50per {
        padding-left: 50%;
    }

    .sm\\:pt-100 {
        padding-top: 100px;
    }

    .sm\\:opacity-full {
        opacity: 1;
    }
}

@media (min-width: 768px) {
       .md\\:text-65px {    
        font-size: 65px;
    }

    .md\\:text-20px {
        font-size: 1.25rem;
    }

    .md\\:inline {
        display: inline;
    }

    .md\\:block {
        display: block;
    }

    .md\\:flex {
        display: flex;
    }

    .md\\:hidden {
        display: none;
    }
    
    .md\\:auto {
        width: auto;
    }

    .md\\:justify-center {
        justify-content: center;
    }

}`, "",{"version":3,"sources":["webpack://./client/index.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,4BAA4B;IAC5B,gCAAgC;IAChC,0BAA0B;;IAE1B,6BAA6B;IAC7B,gCAAgC;IAChC,6BAA6B;IAC7B,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,SAAS;IACT,iCAAiC;IACjC,iBAAiB;IACjB,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;GAEG;;AAEH;IACI,8CAA8C;AAClD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,2CAA2C;IAC3C,2BAA2B;IAC3B,2CAA2C;IAC3C,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;;AAE/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6CAA6C;IAC7C,uBAAuB;;AAE3B;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;OACO;QACC,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;IAC3B;;AAEJ","sourcesContent":[":root {\n    --primary-color-dark:#95b2d0;\n    --secondary-color-dark: #245589;\n    --accent-color-dark: #4894e5;\n    --background-color-dark: #040506;\n    --text-color-dark: #eff0f1;\n\n    --primary-color-light:#2f4c6a;\n    --secondary-color-light: #76a7db;\n    --accent-color-light: #1a66b7;\n    --background-color-light: #f9fafb;\n    --text-color-light: #0e0f10;\n}\n\n* {\n    margin: 0;\n    padding: 0;\n    /* border: 1px solid red; */\n}\n\nbody{\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    margin: 0;\n    font-family: 'Roboto', sans-serif;\n    min-height: 100vh;\n    overflow-x: hidden;\n    background-color: var(--background-color-dark);\n}\n\nbutton {\n    font-family: 'Roboto', sans-serif;\n}\n\nheader {\n    background-color: var(--background-color-dark);\n}\n\nli {\n    list-style-type: none;\n}\n\n.block {\n    display: block;\n}\n\n.inline {\n    display: inline;\n}\n\n.flex {\n    display: flex;\n}\n\n.hidden {\n    display: none;\n}\n\n.over-hidden {\n    overflow-x: hidden;\n}\n\n.wrap {\n    flex-wrap: wrap;\n}\n\n.justify-between {\n    justify-content: space-between;\n}\n\n.justify-center {\n    justify-content: center;\n}\n\n.justify-stretch {\n    justify-content: stretch;\n}\n\n.items-center {\n    align-items: center;\n}\n\n.text-center {\n    text-align: center;\n}\n\n.text-white {\n    color: var(--text-color-dark);\n}\n\n.text-primary-dark {\n    color: var(--primary-color-dark);\n}\n\n.text-secondary-dark {\n    color: var(--secondary-color-dark);\n}\n\n.text-accent-dark {\n    color: var(--accent-color-dark);\n}\n\n/* .bg-radient {\n    background-image: ;\n} */\n\n.bg-color-dark {\n    background-color: var(--background-color-dark);\n}\n\n.bg-color-light {\n    background-color: var(--background-color-light);\n}\n\n.accent-color-dark {\n    background-color: var(--accent-color-dark);\n}\n\n.secondary-color-dark {\n    background-color: var(--secondary-color-dark);\n}\n\n.primary-color-dark {\n    background-color: var(--primary-color-dark);\n}\n\n.px-18 {\n    padding-left: 18px;\n    padding-right: 18px;\n}\n\n.px-24 {\n    padding-left: 24px;\n    padding-right: 24px;\n}\n\n.px-48 {\n    padding-left: 3rem;\n    padding-right: 3rem;\n}\n\n.pt-12 {\n    padding-top: 12px;\n}\n\n.py-12 {\n    padding-top: 12px;\n    padding-bottom: 12px;\n}\n\n.py-18 {\n    padding-top: 18px;\n    padding-bottom: 18px;\n}\n\n.pl-50per {\n    padding-left: 50%;\n}\n\n.pl-16 {\n    padding-left: 1rem;\n}\n\n.p-46 {\n    padding: 46px;\n}\n\n.m-36 {\n    margin-right: 36px;\n}\n\n.m-8 {\n    margin-right: 8px;\n}\n\n.mt-42 {\n    margin-top: 44px;\n}\n\n.mt-24 {\n    margin-top: 24px;\n}\n\n.mt-16 {\n    margin-top: 1rem;\n}\n\n.mb-8 {\n    margin-bottom: 8px;\n}\n\n.mb-16 {\n    margin-bottom: 16px;\n}\n\n.no-underline {\n    text-decoration: none;\n}\n\n.no-border {\n    border: none;\n}\n\n.br-5 {\n    border-radius: 5px;\n}\n\n.br-10 {\n    border-radius: 10px;\n}\n\n.bold {\n    font-weight: bold;\n}\n\n.uppercase {\n    text-transform: uppercase;\n}\n\n.letter-spacing {\n    letter-spacing: 1px;\n}\n\n.letter-spacing-13 {\n    letter-spacing: 0.13px;\n}\n\n.w-full {\n    width: 100%;\n}\n\n.h-full {\n    height: 100%;\n}\n\nh-100 {\n    height: 100vh;\n}\n\n.max-img {\n    max-height: 100%;\n    max-width: 100%;\n}\n\n.object-contain {\n    object-fit: contain;\n}\n\n.relative {\n    position: relative;\n}\n\n.absolute {\n    position: absolute;\n}\n\n.z-10 {\n    z-index: 10;\n}\n\n.mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.mx-width {\n    max-width: 1200px;\n}\n\n.mx-img-section {\n    max-width: 800px;\n    max-height: 500px;\n    margin: 0 auto;\n}\n\n.box-shadow {\n    box-shadow: 0 5px 10px rgba(0,0,0,0.2);\n}\n\n.opacity-light {\n    opacity: 0.33;\n}\n\n.sidebar {\n    position: fixed;\n    top: 0;\n    right: 0;\n    height: 100vh;\n    width: 250px;\n    z-index: 999;\n    background-color: var(--primary-color-dark);\n    backdrop-filter: blur(10px);\n    box-shadow: -10px 0 10px rgba(0, 0, 0, 0.1);\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    \n}\n\n.sidebar li {\n    width:100%;\n}\n\n.sidebar a {\n    width:100%;\n}\n\n.nav-hover:hover {\n    background-color: var(--accent-color-dark);\n    border-radius: 3px;\n}\n\n.nav-button {\n    transition: transform 0.3 ease;\n}\n\n.nav-button:hover {\n    background-color: var(--secondary-color-dark);\n    transform: scale(1.125);\n\n}\n\n@media (min-width: 640px) {\n    .sm\\:text-55px {    \n        font-size: 55px;\n    }\n\n    .sm\\:text-20px {\n        font-size: 1.125rem;\n    }\n\n    .sm\\:inline {\n        display: inline;\n    }\n\n    .sm\\:mt--16 {\n        margin-top: -16px;\n    }\n\n    .sm\\:hidden {\n        display: none;\n    }\n\n    .sm\\:flex {\n        display: flex;\n    }\n\n    .sm\\:pl-50per {\n        padding-left: 50%;\n    }\n\n    .sm\\:pt-100 {\n        padding-top: 100px;\n    }\n\n    .sm\\:opacity-full {\n        opacity: 1;\n    }\n}\n\n@media (min-width: 768px) {\n       .md\\:text-65px {    \n        font-size: 65px;\n    }\n\n    .md\\:text-20px {\n        font-size: 1.25rem;\n    }\n\n    .md\\:inline {\n        display: inline;\n    }\n\n    .md\\:block {\n        display: block;\n    }\n\n    .md\\:flex {\n        display: flex;\n    }\n\n    .md\\:hidden {\n        display: none;\n    }\n    \n    .md\\:auto {\n        width: auto;\n    }\n\n    .md\\:justify-center {\n        justify-content: center;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
